/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PointRuleDto,
  ProblemDetails,
  SavePointRuleCommand,
  SetPointRuleActiveRequest,
  ValidationProblemDetails
} from '.././model';

import { request } from '../../http-client';




export const getApiV1PointRules = (
    
 signal?: AbortSignal
) => {
      
      
      return request<PointRuleDto[]>(
      {url: `/api/v1/point-rules`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1PointRulesQueryKey = () => {
    return [
    `/api/v1/point-rules`
    ] as const;
    }

    
export const getGetApiV1PointRulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1PointRules>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1PointRules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1PointRulesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1PointRules>>> = ({ signal }) => getApiV1PointRules(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1PointRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1PointRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1PointRules>>>
export type GetApiV1PointRulesQueryError = ProblemDetails


export function useGetApiV1PointRules<TData = Awaited<ReturnType<typeof getApiV1PointRules>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1PointRules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1PointRules>>,
          TError,
          Awaited<ReturnType<typeof getApiV1PointRules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1PointRules<TData = Awaited<ReturnType<typeof getApiV1PointRules>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1PointRules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1PointRules>>,
          TError,
          Awaited<ReturnType<typeof getApiV1PointRules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1PointRules<TData = Awaited<ReturnType<typeof getApiV1PointRules>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1PointRules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1PointRules<TData = Awaited<ReturnType<typeof getApiV1PointRules>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1PointRules>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1PointRulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putApiV1PointRules = (
    savePointRuleCommand: SavePointRuleCommand,
 ) => {
      
      
      return request<void>(
      {url: `/api/v1/point-rules`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: savePointRuleCommand
    },
      );
    }
  


export const getPutApiV1PointRulesMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1PointRules>>, TError,{data: SavePointRuleCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1PointRules>>, TError,{data: SavePointRuleCommand}, TContext> => {

const mutationKey = ['putApiV1PointRules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1PointRules>>, {data: SavePointRuleCommand}> = (props) => {
          const {data} = props ?? {};

          return  putApiV1PointRules(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1PointRulesMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1PointRules>>>
    export type PutApiV1PointRulesMutationBody = SavePointRuleCommand
    export type PutApiV1PointRulesMutationError = ValidationProblemDetails | ProblemDetails

    export const usePutApiV1PointRules = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1PointRules>>, TError,{data: SavePointRuleCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1PointRules>>,
        TError,
        {data: SavePointRuleCommand},
        TContext
      > => {

      const mutationOptions = getPutApiV1PointRulesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1PointRulesCodeActive = (
    code: string,
    setPointRuleActiveRequest: SetPointRuleActiveRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/point-rules/${code}/active`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setPointRuleActiveRequest, signal
    },
      );
    }
  


export const getPostApiV1PointRulesCodeActiveMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1PointRulesCodeActive>>, TError,{code: string;data: SetPointRuleActiveRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1PointRulesCodeActive>>, TError,{code: string;data: SetPointRuleActiveRequest}, TContext> => {

const mutationKey = ['postApiV1PointRulesCodeActive'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1PointRulesCodeActive>>, {code: string;data: SetPointRuleActiveRequest}> = (props) => {
          const {code,data} = props ?? {};

          return  postApiV1PointRulesCodeActive(code,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1PointRulesCodeActiveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1PointRulesCodeActive>>>
    export type PostApiV1PointRulesCodeActiveMutationBody = SetPointRuleActiveRequest
    export type PostApiV1PointRulesCodeActiveMutationError = ProblemDetails

    export const usePostApiV1PointRulesCodeActive = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1PointRulesCodeActive>>, TError,{code: string;data: SetPointRuleActiveRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1PointRulesCodeActive>>,
        TError,
        {code: string;data: SetPointRuleActiveRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1PointRulesCodeActiveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    